import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex justify-center',
    text: 'heading-s',
    button:
      'heading-m-regular text-tertiary hover:text-accent cursor-pointer transition-colors'
  },
  variants: {},
  defaultVariants: {}
});
